declare global {
    interface Window {
        dataLayer: any,
    }
}

export default function addMetric(event: string, product:string | null = null) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    if (product) {
      return window.dataLayer.push({ event, product });
    }
    return window.dataLayer.push({ event });
  }
